<template>
  <div>
    <Card>
      <template #title>Órgãos</template>
      <template #content>
        <DataTable
          class="p-datatable-sm"
          :paginator="true"
          :rows="5"
          stripedRows
          :loading="loading"
          :value="orgaos"
          dataKey="id"
          :filters.sync="filtros"
          :globalFilterFields="['nome', 'sigla']"
          filterDisplay="menu"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} órgãos"
          responsiveLayout="scroll">
          <template #header>
            <span class="mt-2 mr-2 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filtros['global'].value"
                placeholder="Pesquisar"
                style="width: 100%" />
            </span>
            <Button
              icon="pi pi-filter-slash"
              label="Limpar"
              class="mt-2 mr-2 p-button-outlined"
              @click="limparFiltro" />
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="mt-2 mr-2 p-button-success float-right"
              @click="showFormOrgao()" />
          </template>
          <Column field="id" header="ID"></Column>
          <Column field="nome" header="Nome"></Column>
          <Column field="sigla" header="Sigla"></Column>
          <Column header="Status">
            <template #body="slotProps">
              <Chip
                v-if="slotProps.data.ativo"
                label="ATIVO"
                class="mr-2 mb-2 custom-chip emUso" />
              <Chip
                v-else
                label="INATIVO"
                class="mr-2 mb-2 custom-chip foraUso" />
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                v-tooltip.left="'Editar'"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning mr-2"
                @click="showFormOrgao(slotProps.data)" />

              <Button
                v-tooltip.left="'Excluir'"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeleteOrgao(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
      </template>
      <template #footer> </template>
    </Card>
    <Dialog
      modal
      header="Header"
      :style="{ width: '350px' }"
      :visible.sync="deleteOrgaoDialog">
      <template #header>
        <h3>Excluir Orgão</h3>
      </template>

      Confirma a exclusão de {{ orgao.nome }} ?

      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteOrgaoDialog = false" />
        <Button label="Sim" icon="pi pi-check" autofocus @click="deleteOrgao" />
      </template>
    </Dialog>
    <Toast />
    <OrgaoForm
      :visible.sync="showOrgaoFormDialog"
      :propsorgao="orgao"
      :update="update"
      @onUpdate="onUpdateOrgao" />
  </div>
</template>

<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api/'
import OrgaoForm from './OrgaoForm.vue'
import OrgaoService from '@/service/OrgaoService.js'

export default {
  components: {
    OrgaoForm,
  },
  data() {
    return {
      orgaos: null,
      orgao: {},
      deleteOrgaoDialog: false,
      filtros: {},
      loading: false,
      showOrgaoFormDialog: false,
      update: false,
    }
  },

  created() {
    this.orgaoService = new OrgaoService(this.$http)
    this.initFiltros()
  },

  mounted() {
    this.orgaoService.getOrgaos().then((res) => (this.orgaos = res))
  },

  methods: {
    limparFiltro() {
      this.initFiltros()
    },
    showFormOrgao(data) {
      if (data) {
        this.orgao = data
        this.update = true
      } else {
        this.orgao = {}
        this.update = false
      }
      this.showOrgaoFormDialog = true
    },
    onUpdateOrgao(event) {
      let index = this.orgaos.findIndex((o) => o.id === event.id)
      index != -1
        ? this.$set(this.orgaos, index, event)
        : this.orgaos.unshift(event)
    },
    initFiltros() {
      this.filtros = {
        global: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.CONTAINS },
            { value: null, matchMode: FilterMatchMode.EQUALS },
          ],
        },
      }
    },

    confirmDeleteOrgao(data) {
      this.deleteOrgaoDialog = true
      this.orgao = data
    },

    orgaoNew() {
      this.$router.push({ name: 'orgao-new' })
    },

    editOrgao(data) {
      this.$router.push({ name: 'orgao-edit', params: { id: data.id } })
    },

    deleteOrgao() {
      this.deleteOrgaoDialog = false
      this.orgaoService
        .deleteOrgao(this.orgao)
        .then(() => {
          this.orgaoService.getOrgaos().then((res) => (this.orgaos = res))
          this.orgao = {}
          this.$toast.add({
            severity: 'success',
            summary: 'Excluido com sucesso!',
            life: 10000,
          })
        })
        .catch((err) => {
          this.$toast.add({
            severity: 'error',
            summary: err.response.data.message,
            life: 10000,
          })
        })
    },
  },
}
</script>

<style>
.foraUso {
  color: #fff;
  background-color: #dc3545;
  font-weight: bold;
  text-align: center;
}
.emUso {
  color: #fff;
  background-color: #28a745;
  font-weight: bold;
  text-align: center;
}
</style>
